export default "__VITE_ASSET__CuzXFkmP__"